// extracted by mini-css-extract-plugin
export default {"root":"Rewards_root__36uta","seasonWrapper":"Rewards_seasonWrapper__Nn4Ei"};